import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BdsTypo,
  BdsButton,
} from '@/core/constants/webComponents';

interface FooterProps {
  updateTimeAgo: string | undefined;
  onDispatch: (eventName: string, extra?: Record<string, unknown>) => void;
  CLASSIFICATION_EVENTS: any;
  isSpam: boolean;
}

export const Footer: React.FC<FooterProps> = ({
  updateTimeAgo,
  onDispatch,
  CLASSIFICATION_EVENTS,
  isSpam,
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  // Reset loading state on success or error for both actions
  useEffect(() => {
    const handleDone = () => setIsLoading(false);

    document.addEventListener(CLASSIFICATION_EVENTS.NOTIFY_REMOVE_FROM_SEARCH_SUCCESS, handleDone);
    document.addEventListener(CLASSIFICATION_EVENTS.NOTIFY_REMOVE_FROM_SEARCH_ERROR, handleDone);

    return () => {
      document.removeEventListener(CLASSIFICATION_EVENTS.NOTIFY_REMOVE_FROM_SEARCH_SUCCESS, handleDone);
      document.removeEventListener(CLASSIFICATION_EVENTS.NOTIFY_REMOVE_FROM_SEARCH_ERROR, handleDone);
    };
  }, [CLASSIFICATION_EVENTS]);

  const handleClick = () => {
    setIsLoading(true);
    onDispatch(CLASSIFICATION_EVENTS.REMOVE_FROM_SEARCH, { spam: isSpam });
    // Safety fallback: re-enable after 10s if warroom never responds
    setTimeout(() => setIsLoading(false), 10_000);
  };
  return (
    <div className="classification-card__footer">
      <BdsTypo
        class="classification-card__edited-at"
        tag="span"
        variant="fs-10"
        italic
        margin={false}
      >
        {updateTimeAgo}
      </BdsTypo>
      <BdsButton
        variant="text"
        icon={isSpam ? 'redo' : 'trash'}
        color={isSpam ? 'content' : 'negative'}
        size="short"
        disabled={isLoading}
        onClick={handleClick}
      >
        {isSpam
          ? t('multipleEdition.restoreButton')
          : t('classificationCard.removeFromSearch')}
      </BdsButton>
    </div>
  );
};
